/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
  AppModeStatus,
  OfflineModeService
} from '../../services/offline-mode.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(protected offlineService: OfflineModeService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.status === 200) {
          // Успешный ответ — связь есть
          this.setStatus(AppModeStatus.ONLINE);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Только обрыв связи (status 0) — офлайн; прочие ошибки означают, что связь есть
        this.setStatus(
          error.status === 0 ? AppModeStatus.OFFLINE : AppModeStatus.ONLINE
        );
        return throwError(() => error);
      })
    );
  }

  private setStatus(newStatus: AppModeStatus): void {
    this.offlineService.appModeStatus$.next(newStatus);
  }
}
